<template>
  <appFaq></appFaq>
</template>
<script>
import appFaq from '../../components/comm/Faq.vue'

export default {
  name: 'FAQ',
  components: {
    appFaq
  }
}
</script>